document.addEventListener('DOMContentLoaded', () => {
    const interviewTimeInput = document.getElementById('interviewTime');
    const timerDisplay = document.getElementById('timerDisplay');
    const timerMessage = document.getElementById('timerMessage');
    
    const daysEl = document.getElementById('days');
    const hoursEl = document.getElementById('hours');
    const minutesEl = document.getElementById('minutes');
    const secondsEl = document.getElementById('seconds');
    
    const checklistItems = document.querySelectorAll('.checklist-item');
    
    let timerInterval;

    function updateChecklist(daysRemaining) {
        checklistItems.forEach(item => {
            const phase = parseInt(item.getAttribute('data-phase'));
            const checkbox = item.querySelector('input[type="checkbox"]');
            
            if (daysRemaining <= phase) {
                item.classList.add('active');
                // if they are inside the phase time, uncheck it if it's a fresh phase
            } else {
                item.classList.remove('active');
            }
        });
    }

    function calculateTime() {
        const targetDate = new Date(interviewTimeInput.value).getTime();
        
        if (isNaN(targetDate)) {
            resetTimer();
            return;
        }

        const now = new Date().getTime();
        const difference = targetDate - now;

        if (difference <= 0) {
            clearInterval(timerInterval);
            timerDisplay.style.display = 'none';
            timerMessage.style.display = 'block';
            updateChecklist(0);
            return;
        } else {
            timerDisplay.style.display = 'flex';
            timerMessage.style.display = 'none';
        }

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        daysEl.textContent = days.toString().padStart(2, '0');
        hoursEl.textContent = hours.toString().padStart(2, '0');
        minutesEl.textContent = minutes.toString().padStart(2, '0');
        secondsEl.textContent = seconds.toString().padStart(2, '0');
        
        updateChecklist(days);
    }

    function resetTimer() {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        timerDisplay.style.display = 'flex';
        timerMessage.style.display = 'none';
    }

    interviewTimeInput.addEventListener('change', () => {
        clearInterval(timerInterval);
        calculateTime();
        timerInterval = setInterval(calculateTime, 1000);
        
        // Save to local storage
        localStorage.setItem('resumeMetric_interviewDate', interviewTimeInput.value);
    });

    // Load from local storage if exists
    const savedDate = localStorage.getItem('resumeMetric_interviewDate');
    if (savedDate) {
        interviewTimeInput.value = savedDate;
        calculateTime();
        timerInterval = setInterval(calculateTime, 1000);
    } else {
        // Default to tomorrow at 10 AM
        const tmrw = new Date();
        tmrw.setDate(tmrw.getDate() + 1);
        tmrw.setHours(10, 0, 0, 0);
        
        // format for datetime-local
        const offset = tmrw.getTimezoneOffset() * 60000;
        const localISOTime = (new Date(tmrw - offset)).toISOString().slice(0, 16);
        interviewTimeInput.value = localISOTime;
        calculateTime();
        timerInterval = setInterval(calculateTime, 1000);
    }
});
